import { render, staticRenderFns } from "./ProfileDocument.vue?vue&type=template&id=5c22176f"
import script from "./ProfileDocument.vue?vue&type=script&lang=js"
export * from "./ProfileDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports